import { useEffect, useState } from 'react';
import type { HardwareAsset } from '@ddp/shared';

import { apiFetch } from '../../api/client.js';

/** Appareil de captation présenté dans les sélecteurs : identité minimale, suffisante pour l'IHM. */
export interface CaptureAsset {
  id: string;
  name: string;
}

/**
 * Appareils de captation de la flotte (drones et UGV uniquement, ADR-0039), triés par nom. Sert à
 * rattacher une session de vol à un matériel et à filtrer les vidéos par appareil (FR-20). Seules ces
 * familles « ont volé/roulé » pour capter — c'est aussi ce que le serveur accepte au rattachement.
 *
 * Un rôle sans accès à la flotte (ou une absence de matériel) renvoie une liste vide, sans bloquer la
 * page : les sélecteurs se masquent alors d'eux-mêmes.
 */
export function useCaptureAssets(): CaptureAsset[] {
  const [assets, setAssets] = useState<CaptureAsset[]>([]);

  useEffect(() => {
    let active = true;
    apiFetch<HardwareAsset[]>('/hardware')
      .then((list) => {
        if (!active) return;
        setAssets(
          list
            .filter((asset) => asset.kind === 'DRONE' || asset.kind === 'UGV')
            .map((asset) => ({ id: asset.id, name: asset.name }))
            .sort((a, b) => a.name.localeCompare(b.name)),
        );
      })
      .catch(() => {
        if (active) setAssets([]);
      });
    return () => {
      active = false;
    };
  }, []);

  return assets;
}
